import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/idlefish-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-56aa383a")

_pushScopeId("data-v-56aa383a")
const _hoisted_1 = { class: "ui__reportCarInfo_main" }
const _hoisted_2 = { class: "ui__reportCarInfo_content" }
const _hoisted_3 = { class: "ui__reportCarInfo_box" }
const _hoisted_4 = { class: "ui__reportCarInfo_img" }
const _hoisted_5 = { class: "ui__reportCarInfo_modal" }
const _hoisted_6 = { class: "ui__reportCarInfo_modal_type" }
const _hoisted_7 = { class: "ui__reportCarInfo_modal_vin" }
const _hoisted_8 = {
  key: 0,
  class: "ui__reportCarInfo_logo"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "bottom-line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.carImg,
            alt: "45°",
            style: {"pointer-events":"none"}
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.state.carModel), 1),
          _createVNode("div", _hoisted_7, "VIN：" + _toDisplayString(_ctx.state.vin), 1)
        ]),
        (_ctx.state.sealType === 'xianyu')
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_10
    ])
  ]))
})